import { Fab, Tooltip } from "@material-ui/core";
import { Search } from "@material-ui/icons";
import { Grid, TextField } from "@mui/material";
import Select from "components/select/Select";
import { useGetListBusiness } from "service/query/business-management.query";
import { useGetListExtensionContactCenter } from "service/query/extension.query";
import { getSelectFieldProps, getTextFieldProps } from "ultis/form";

const BusinessExtensionFilter = ({ formik }) => {
  const { data: listBusiness } = useGetListBusiness();
  const { data: listProvince } = useGetListExtensionContactCenter({
    typeProvince: "all",
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={3}>
          <Select
            {...getSelectFieldProps(formik, "businessCode")}
            label="Nghiệp vụ"
            options={listBusiness?.map((item) => ({
              label: item.name,
              value: item.businessCode,
            }))}
            showAllOption
          />
        </Grid>

        <Grid item xs={3}>
          <Select
            {...getSelectFieldProps(formik, "cityCode")}
            label="Bưu cục"
            options={
              listProvince?.map((item) => ({
                label: item.name,
                value: item.code,
              })) || []
            }
            isMulti
            showAllOption
          />
        </Grid>

        <Grid item xs={3}>
          <TextField {...getTextFieldProps(formik, "name")} label="Máy lẻ" />
        </Grid>

        <Grid item xs={2}>
          <Tooltip title="Tìm kiếm" disableFocusListener>
            <Fab color="primary" aria-label="Search" type="submit">
              <Search />
            </Fab>
          </Tooltip>
        </Grid>
      </Grid>
    </form>
  );
};

export default BusinessExtensionFilter;
